import React from 'react';
import { compose } from 'redux';
import { filter } from '@beef/utils';
import { withErrorBoundary } from '@beef/react';
import { withReduxStore } from '@beef/redux';
import { initializeModuleStore } from "../../store/store";
import { ThreeDSPayment } from "./ThreeDSPaymentResult";
var IGNORED_STORE_PROPS = ['onContinue'];
var mapPropsToState = function mapPropsToState(props) {
  return filter(props, function (_, key) {
    return !IGNORED_STORE_PROPS.includes(key);
  });
};
var passThroughProps = function passThroughProps(props) {
  return filter(props, function (_, key) {
    return IGNORED_STORE_PROPS.includes(key);
  });
};
export var ThreeDSPaymentResult = compose(React.memo, withErrorBoundary(), withReduxStore(initializeModuleStore, {
  mapPropsToState: mapPropsToState,
  passThroughProps: passThroughProps
}))(ThreeDSPayment);